import React, { Fragment } from "react";
import Input from "../UI/Input";

const OrderScanDetails = ({ orderObj, inputChangedHandler }) => {
  return (
    <Fragment>
      <div style={{ width: "100%" }}>
        <table style={{ width: "100%" }} >
          <tr style={{ width: "100%" }}>
            <td title={"Modality"}>Mod:</td>
            <td>
              <Input
                id="modality"
                key="modality"
                name="modality"
                width="96%"
                placeholder="Modality"
                Value={orderObj.modality ? orderObj.modality.toUpperCase() : ""}
                onChange={(event) => inputChangedHandler(event, "modality")}
                disabled={true}
              />
            </td>

            <td title={"Bodypart"}>BP:</td>
            <td >
              <Input
                textTransform="capitalize"
                id="body_part"
                key="bodypart"
                name="bodypart"
                width="100%"
                placeholder="Bodypart"
                Value={orderObj.bodypart}
                onChange={(event) => inputChangedHandler(event, "bodypart")}
                disabled={true}
              />
            </td>
          </tr>
          <tr>
            <td
              title={"Study Protocol"}
            >
              PT:
            </td>
            <td>
              <Input
                id="protocol"
                key="protocol"
                label="protocol"
                name="protocol"
                textTransform="capitalize"
                width="96%"
                placeholder="protocol"
                Value={orderObj.protocol}
                onChange={(event) => inputChangedHandler(event, "protocol")}
                disabled={true}
              />
            </td>
            <td
              title={"Purpose of study"}
            >
              PP:
            </td>
            <td>
              {" "}
              <Input
                id="purposeOfStudy"
                key="purposeOfStudy"
                label="purposeOfStudy"
                name="purposeOfStudy"
                textTransform="capitalize"
                width="100%"
                placeholder="Purpose of study"
                Value={orderObj.purposeOfStudy}
                onChange={(event) =>
                  inputChangedHandler(event, "purposeOfStudy")
                }
                disabled={true}
              />
            </td>

          </tr>
          <tr>
            <td title={"Laterality"}>
              Lat:
            </td>
            <td>
              <Input
                id="laterality"
                key="laterality"
                label="laterality"
                name="laterality"
                textTransform="capitalize"
                width="96%"
                placeholder="laterality"
                Value={orderObj.laterality}
                onChange={(event) => inputChangedHandler(event, "laterality")}
                disabled={true}
              />
            </td>
            <td
              title={"Bodypart group"}
            >
              BG:
            </td>
            <td>
              <Input
                id="bodypartGroup"
                key="bodypartGroup"
                label="bodypartGroup"
                name="bodypartGroup"
                textTransform="capitalize"
                width="100%"
                placeholder="Bodypart group"
                Value={orderObj.bodypartGroup}
                onChange={(event) =>
                  inputChangedHandler(event, "bodypartGroup")
                }
                disabled={true}
              />
            </td>
          </tr>
          <tr>
            <td title={"RIS Service Code"}>
              RSC:
            </td>
            <td>
              <Input
                id="ris_service_code"
                key="ris_service_code"
                label="ris_service_code"
                name="ris_service_code"
                textTransform="capitalize"
                width="96%"
                placeholder="RIS Service Code"
                Value={[orderObj?.ris_service_code, orderObj?.ris_service_code_2].filter(Boolean).join(", ")}
                onChange={(event) => inputChangedHandler(event, "ris_service_code")}
                disabled={true}
              />
            </td>
            <td></td>
            <td></td>
          </tr>
          <div style={{ width: "100%", marginTop: "5px", marginBottom: "5px" }}></div>
          <tr style={{ border: "1px solid lightgrey" }}></tr>
          <div style={{ width: "100%", marginTop: "5px", marginBottom: "5px" }}></div>

          <tr>
            <td
              title={"Modality generic"}
            >
              Mod-G:
            </td>
            <td >
              <Input
                id="modalityGeneric"
                key="modalityGeneric"
                name="modalityGeneric"
                width="96%"
                placeholder="Modality Generic"
                Value={
                  orderObj.modalityGeneric
                    ? orderObj.modalityGeneric.toUpperCase()
                    : ""
                }
                onChange={(event) =>
                  inputChangedHandler(event, "modalityGeneric")
                }
                disabled={true}
              />
            </td>
            <td
              title={"Bodypart generic"}
            >
              BP-G:
            </td>
            <td >
              <Input
                textTransform="capitalize"
                id="bodypartGeneric"
                key="bodypartGeneric"
                name="bodypartGeneric"
                width="100%"
                placeholder="Bodypart Generic"
                Value={orderObj.bodypartGeneric}
                onChange={(event) =>
                  inputChangedHandler(event, "bodypartGeneric")
                }
                disabled={true}
              />
            </td>
          </tr>
          <tr>
            <td
              title={"Study Protocol generic"}
            >
              PT-G:
            </td>
            <td>
              <Input
                id="protocolGeneric"
                key="protocolGeneric"
                label="protocolGeneric"
                name="protocolGeneric"
                textTransform="capitalize"
                width="96%"
                placeholder="Protocol Generic"
                Value={orderObj.protocolGeneric}
                onChange={(event) =>
                  inputChangedHandler(event, "protocolGeneric")
                }
                disabled={true}
              />
            </td>
            <td
              title={"Purpose of study generic"}
            >
              PP-G:
            </td>
            <td>
              {" "}
              <Input
                id="purposeOfStudyGeneric"
                key="purposeOfStudyGeneric"
                label="purposeOfStudyGeneric"
                name="purposeOfStudyGeneric"
                textTransform="capitalize"
                width="100%"
                placeholder="Purpose Of Study Generic"
                Value={orderObj.purposeOfStudyGeneric}
                onChange={(event) =>
                  inputChangedHandler(event, "purposeOfStudyGeneric")
                }
                disabled={true}
              />
            </td>
          </tr>

          <tr>
            <td
              title={"Laterality generic"}
            >
              LT-G:
            </td>
            <td>
              <Input
                id="lateralityGeneric"
                key="lateralityGeneric"
                label="lateralityGeneric"
                name="lateralityGeneric"
                textTransform="capitalize"
                width="96%"
                placeholder="Laterality Generic"
                Value={orderObj.lateralityGeneric}
                onChange={(event) =>
                  inputChangedHandler(event, "lateralityGeneric")
                }
                disabled={true}
              />
            </td>
            <td
              title={"Bodypart group generic"}
            >
              BG-G:
            </td>
            <td>
              <Input
                id="bodypartGroupGeneric"
                key="bodypartGroupGeneric"
                label="bodypartGroupGeneric"
                name="bodypartGroupGeneric"
                textTransform="capitalize"
                width="100%"
                placeholder="Bodypart Group Generic"
                Value={orderObj.bodypartGroupGeneric}
                onChange={(event) =>
                  inputChangedHandler(event, "bodypartGroupGeneric")
                }
                disabled={true}
              />
            </td>
          </tr>
          <tr>
            <td
              title={"speciality"}
            >
              SPC:
            </td>
            <td>
              <Input
                id="speciality"
                key="speciality"
                label="speciality"
                name="speciality"
                textTransform="capitalize"
                width="96%"
                placeholder="speciality"
                Value={orderObj.speciality}
                onChange={(event) =>
                  inputChangedHandler(event, "speciality")
                }
                disabled={true}
              />
            </td>
            <td></td>
            <td></td>
          </tr>
        </table>

      </div>
    </Fragment>
  );
};

export default OrderScanDetails;
